import constants from "./CONSTANTS";

const localStorageLang = localStorage.getItem("lang");

export const initState = {
  lang: localStorageLang ?? "ge",
  additionalTranslations: { en: {}, ge: {} },
  sidebarOpen: true,
  apiCallExecuted: 0,
  moduleLoaded: {},

  darkMode: false
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case constants.SET_LANGUAGE:
      return {
        ...state,
        lang: action.lang,
      };
    case constants.SET_SIDEBAR_OPEN:
      return {
        ...state,
        sidebarOpen: action.status,
      };
    case constants.TOGGLE_SIDEBAR_OPEN:
      return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
      }
    case constants.RESET_COMMON:
      return {
        ...initState,
      };
    case constants.SET_API_CALL_EXECUTED:
      return {
        ...state,
        apiCallExecuted: !state.apiCallExecuted
      }
    case constants.ADD_ADDITIONAL_TRANSLATIONS:
      return {
        ...state,
        additionalTranslations: {
          en: {
            ...state.additionalTranslations.en,
            ...action.payload.en
          },
          ge: {
            ...state.additionalTranslations.ge,
            ...action.payload.ge
          },
        }
      }
    case constants.MODULE_LOADED:
      return {
        ...state,
        moduleLoaded: {
          ...state.moduleLoaded,
          [action.payload]: true
        }
      }
    case constants.SET_APPLICATION_DARK_MODE:
      return {
        ...state,
        darkMode: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
